Date.prototype.toDateInputValue = (function() {
  var local = new Date(this)
  local.setMinutes(this.getMinutes() - this.getTimezoneOffset())
  return local.toJSON().slice(0,10)
})

Date.prototype.toDateTimeInput = (function() {
  const local = new Date(this)

  let hours = local.getHours()
  if (hours < 10) {
    hours = '0' + hours
  }

  let minutes = local.getMinutes()
  if (minutes < 10) {
    minutes = '0' + minutes
  }

  return hours + ':' + minutes
})


Date.prototype.toDisplay = (function(full = false) {
  var local = new Date(this)

  let day = local.getDate()
  if (day < 10) {
      day = '0' + day
  }

  let month = local.getMonth() + 1
  if (month < 10) {
      month = '0' + month
  }

  const year = local.getFullYear()

  const date = day + '/' + month + '/' + year

  if (full) {
    let hours = local.getHours()
    if (hours < 10) {
      hours = '0' + hours
    }

    let minutes = local.getMinutes()
    if (minutes < 10) {
      minutes = '0' + minutes
    }

    let seconds = local.getSeconds()
    if (seconds < 10) {
      seconds = '0' + seconds
    }


    return date + ' ' + hours + ':' + minutes + ':' + seconds
  } else {
    return date
  }
})

Date.prototype.getFirstDayMonth = (function() {
  const date = new Date()
  return new Date(date.getFullYear(), date.getMonth(), 1)
})

Date.prototype.getLastDayMonth = (function() {
  const date = new Date()
  return new Date(date.getFullYear(), date.getMonth() + 1, 0)
})

Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf())
  date.setDate(date.getDate() + days)
  return date
}

Date.prototype.removeDays = function(days) {
  var date = new Date(this.valueOf())
  date.setDate(date.getDate() - days)
  return date
}

Object.defineProperty(String.prototype, 'capitalize', {
  value: function() {
    return this.charAt(0).toUpperCase() + this.slice(1)
  },
  enumerable: false
})

import utilsImplant from "../../backend/commons/utils.implant.mjs"

const utils = {...utilsImplant}
const guardedForms = ['client', 'place', 'implant', 'operation', 'call', 'order', 'product']
const draftInitializedRefs = new WeakSet()
const draftSkipNextRefs = new WeakSet()
const draftDebouncedRefs = new WeakMap()
const draftPendingValues = new WeakMap()

utils.guardedForms = guardedForms

utils.isGuardedFormPath = (path = '') => {
  const normalized = (path || '').toLowerCase()
  const patterns = [
    /^\/clienti\/(new|[^/]+)$/,
    /^\/luoghi\/(new|[^/]+)$/,
    /^\/impianti\/(new|[^/]+)$/,
    /^\/appuntamenti\/(new|[^/]+)$/,
    /^\/chiamate\/(new|[^/]+)$/,
    /^\/ordini\/(new|[^/]+)$/,
    /^\/magazzino\/(new|[^/]+)$/
  ]

  return patterns.some(regex => regex.test(normalized))
}

utils.getGuardedFormNameByPath = (path = '') => {
  const normalized = (path || '').toLowerCase()

  if (/^\/clienti\/(new|[^/]+)$/.test(normalized)) return 'client'
  if (/^\/luoghi\/(new|[^/]+)$/.test(normalized)) return 'place'
  if (/^\/impianti\/(new|[^/]+)$/.test(normalized)) return 'implant'
  if (/^\/appuntamenti\/(new|[^/]+)$/.test(normalized)) return 'operation'
  if (/^\/chiamate\/(new|[^/]+)$/.test(normalized)) return 'call'
  if (/^\/ordini\/(new|[^/]+)$/.test(normalized)) return 'order'
  if (/^\/magazzino\/(new|[^/]+)$/.test(normalized)) return 'product'

  return null
}

utils.hasUnsavedForms = (store, formNames = guardedForms) => {
  if (!store?.state?.pages) {
    return false
  }

  return formNames.some(name => {
    const form = store.state.pages?.[name]?.form
    return !!(form && form._edited)
  })
}

utils.fullname = (client) => {
  let text = ''
  if (client) {
    if (client.surname) {
      text += client.surname
    }
    if (client.name) {
      text += ' ' + client.name
    }

    if (client.deleted) {
      text += ' (rimosso)'
    }
  }

  return text.trim()
}

utils.addressLine1 = (value) => {
  const parts = [value?.address, value?.floor, value?.interior]
    .map(part => (part || '').toString().trim())
    .filter(Boolean)

  return parts.join(', ')
}

utils.addressLine2 = (value) => {
  const zip = (value?.zip || '').toString().trim()
  const city = (value?.city || '').toString().trim()
  const provinceRaw = (value?.province || '').toString().trim()
  const province = provinceRaw.replace(/[^a-zA-Z]/g, '').toUpperCase().slice(0, 2)

  const base = [zip, city].filter(Boolean).join(' ')
  if (!base && !province) {
    return ''
  }

  if (province) {
    return (base ? base + ' ' : '') + '(' + province + ')'
  }

  return base
}

utils.fulladdress = (value) => {
  const line1 = utils.addressLine1(value)
  const line2 = utils.addressLine2(value)

  return [line1, line2].filter(Boolean).join(' - ').trim()
}

utils.clientName = (client) => {
  let fullname = ''
  let label = ''
  if (client) {
    if (client.surname) {
      fullname += client.surname
    }
    if (client.name) {
      fullname += ' ' + client.name
    }
    fullname = fullname.trim()

    if (client.business_name) {
      label += client.business_name
      if (client.name || client.surname) {
        label += ' (' + fullname + ')'
      }
    } else if (client.name || client.surname) {
      label = fullname
    }
  }

  return label
}

utils.placeName = (place) => {
  return utils.fulladdress(place)
}

utils.generatorNameReg = (generator) => {
  let fullname = utils.generatorName(generator)
  
  if (generator?.registration) {
    fullname += ' ' + generator.registration
  }
  fullname = fullname.trim()

  return fullname
}

utils.implantNameOperation = (operation) => {
  let name = ''
  //name += operation.implantCode + "\n"

  operation.implantGenerators.forEach(gen => {
    name += utils.generatorNameReg(gen) + "\n"
  })

  return name
}

utils.useImage = (url) => {
  return new URL(`/images/${url}`, import.meta.url).href
}

utils.getFirstDayOfWeek = () => {
  return new Date(new Date().setDate(new Date().getDate() - new Date().getDay()+1))
}

utils.getLastDayOfWeek = () => {
  return new Date(new Date().setDate(new Date().getDate() - new Date().getDay()+7))
}

utils.getFirstDayOfMonth = () => {
  const now = new Date()
  return new Date(now.getFullYear(), now.getMonth(), 1)
}

utils.getLastDayOfMonth = () => {
  const now = new Date()
  return new Date(now.getFullYear(), now.getMonth() + 1, 0)
}

utils.getFirstDayOfPastMonth = () => {
  const now = new Date()
  return new Date(now.getFullYear(), now.getMonth() - 1, 1)
}

utils.getLastDayOfPastMonth = () => {
  const now = new Date()
  return new Date(now.getFullYear(), now.getMonth(), 0)
}

utils.isExpired = (date) => {
  const now = new Date()
  now.setHours(0,0,0,0)

  const toCheck = new Date(date)
  toCheck.setHours(0,0,0,0)

  return now > toCheck
}

utils.getMostRecent = (dates) => {
  return dates.sort((a, b) => {
    return new Date(b.end) - new Date(a.end)
  })[0]
}

utils.getBefore30Day = () => {
  return new Date(new Date().setDate(new Date().getDate() - 30))
}

utils.getAfter30Day = () => {
  return new Date(new Date().setDate(new Date().getDate() + 30))
}

utils.getDrafts = () => {
  let drafts = []
  const draftsRaw = localStorage.getItem('drafts')
  if (draftsRaw) {
    drafts = JSON.parse(draftsRaw)
  }

  return drafts
}

utils.saveDrafts = (drafts) => {
  localStorage.setItem('drafts', JSON.stringify(drafts))
}

utils.updateDrafts = (draft) => {
  let drafts = utils.getDrafts()
  const foundIndex = drafts.findIndex(d => draft.value._timestamp === d.value._timestamp)

  if (foundIndex !== -1) {
    drafts[foundIndex].value = draft.value
  } else {
    drafts.push(draft)
  }

  utils.saveDrafts(drafts)
}

utils.prepareDraft = (self, entity, value, type) => {
  if (!entity || typeof entity !== 'object') {
    return
  }

  if (draftSkipNextRefs.has(entity)) {
    draftSkipNextRefs.delete(entity)
    self.$store.commit('setForm', {name: type, value: value})
    return
  }

  if (self?.waitRecord) {
    if (entity._id) {
      entity._edited = false
      if (!entity._timestamp) {
        entity._timestamp = Date.now()
        draftSkipNextRefs.add(entity)
      }
    }

    self.$store.commit('setForm', {name: type, value: value})
    return
  }

  const keepEditedState = entity._edited === true

  if (!draftInitializedRefs.has(entity)) {
    draftInitializedRefs.add(entity)

    // Existing records should not be marked as edited just by initial data load.
    if (entity._id && !entity._timestamp) {
      entity._timestamp = Date.now()
      entity._edited = keepEditedState
      draftSkipNextRefs.add(entity)
      self.$store.commit('setForm', {name: type, value: value})
      return
    }
  }

  //if (!value._id) {
    if (!entity._timestamp) {
      entity._timestamp = Date.now()
    }
    entity._edited = true

    self.$store.commit('setForm', {name: type, value: value})

    // Reuse the same debounced fn per entity, otherwise every call creates its own timer and nothing gets debounced.
    draftPendingValues.set(entity, value)
    if (!draftDebouncedRefs.has(entity)) {
      draftDebouncedRefs.set(entity, self.$debounce(() => {
        utils.updateDrafts({type: type, value: draftPendingValues.get(entity)})
      }, 1000))
    }
    draftDebouncedRefs.get(entity)()
  //}
}

utils.deleteDraft = (self, timestamp, type) => {
  return new Promise((resolve) => {
    const clearForm = () => {
      self.$store.commit('setForm', {name: type, value: false})
    }

    if (timestamp) {
      const drafts = utils.getDrafts()

      const foundIndex = drafts.findIndex(d => d.value._timestamp === timestamp)

      if (foundIndex !== -1) {
        if (drafts[foundIndex]._id) {
          self.$http.delete('/draft/' + drafts[foundIndex]._id)
            .then(function (response) {
              drafts.splice(foundIndex, 1)
              utils.saveDrafts(drafts)
              clearForm()
              resolve()
            })
            .catch(function (error) {
              console.log(error)
              clearForm()
              resolve()
            })
        } else {
          drafts.splice(foundIndex, 1)
          utils.saveDrafts(drafts)
          clearForm()
          resolve()
        }
      } else {
        clearForm()
        resolve()
      }
    } else {
      clearForm()
      resolve()
    }
  })
}

utils.addElement = (implant, index) => {
  if (!implant[index]) {
    implant[index] = []
  }
  implant[index].push({})
  return implant
}

// cached across all callers so '/client/filter' is fetched once and shared
let clientsPromise = null

utils.fetchClients = (http, force = false) => {
  if (force || !clientsPromise) {
    clientsPromise = http.get('/client/filter')
      .then(response => response?.data || [])
      .catch(error => {
        console.log(error)
        clientsPromise = null
        return []
      })
  }

  return clientsPromise
}

utils.calcPriorityColor = (priority) => {
  if (priority === 'Alta') {
    return '#f5c6cb'
  } else if (priority === 'Media') {
    return '#ffeeba'
  } else if (priority === 'Bassa') {
    return '#d1e7dd'
  } else {
    return 'unset'
  }
}
export default utils